import { EnvironmentInjector, inject, Injectable, runInInjectionContext } from '@angular/core';
import { FirebaseService } from './firebase.service';
import * as _ from 'lodash';
import { first } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DomainService {

    private readonly _injector: EnvironmentInjector = inject(EnvironmentInjector);
    constructor(private firebase: FirebaseService) { }
    getCustomerId(domain: string) {
        return new Promise((resolve, reject) => {
            return runInInjectionContext(this._injector, () => {
                domain = domain.replace(/\./g, '_');
                const ref = `customDomains/${domain}`;
                this.firebase
                    .getByRef(ref)
                    .pipe(first())
                    .subscribe((customerId: any) => {
                        resolve(customerId || '');
                    });
            });
        });

    }
}
